'use client';

import { forwardRef } from 'react';
import MuiSelect, { type SelectProps as MuiSelectProps } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

export type SelectProps = MuiSelectProps<string | number> & {
  helperText?: string;
};

export const Select = forwardRef<HTMLDivElement, SelectProps>(
  ({ label, helperText, error, fullWidth, ...props }, ref) => {
    return (
      <FormControl ref={ref} fullWidth={fullWidth} error={error}>
        {label && <InputLabel>{label}</InputLabel>}
        <MuiSelect label={label} {...props} />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

Select.displayName = 'Select';
